import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createSharedComposable } from '@vueuse/core';
import { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';
import { computed } from 'vue';
import { getIsOversea } from '@telecom/shared/utils/environment';

export const useHeaderService = createSharedComposable(() => {
    const headerServiceInstance = injectService<HeaderServiceProxy>(HeaderServiceProxy);

    const headerService = headerServiceInstance.headerService;
    console.log('headerService',headerService);
    const accountDisplayName = computed(() => {
        const account = headerService.account;
        if (!account) return '';
        return account.username || account.email || account.email;
    });

    const inCN = computed(()=> !getIsOversea());

    return {
        /**
         * 是否在中国
         */
        inCN,
        headerService,
        /**
         * 用户名
         * @description 优先级：username > email > email
         */
        accountDisplayName,
    };
});
